import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './Eksplorasi.css';
import { toast } from 'react-toastify';
import { fetchUserData, getCurrentUser, saveUserData } from '../services/api';
import { migrateLegacyKey, userGetItem, userSetItem } from '../utils/userStorage';
import { useModalA11y } from '../hooks/useModalA11y';
import { ConfirmDialog } from '../components/ui/ConfirmDialog';
import { EmptyList } from '../components/ListState';

// ===== CONSTANTS =====
const EMOJI_OPTIONS = ['🎬', '📖', '🏛️', '🎥', '🌾', '🏝️', '🎨', '📸', '🎧', '📊', '🌟', '✨'];
const COLOR_OPTIONS = ['#2c3e50', '#3498db', '#5dade2', '#2980b9', '#5499c7', '#85c1e9', '#27ae60', '#f39c12'];

const INITIAL_VIDEOS = [
  {
    title: "Cerita Rakyat (Legenda dan Dongeng)",
    url: "https://www.youtube.com/embed/ha8PA-J1IoQ",
    thumbnail: "https://img.youtube.com/vi/ha8PA-J1IoQ/mqdefault.jpg",
    emoji: "📖",
    color: "#2c3e50",
    description: "Mengadaptasi cerita rakyat, legenda, atau dongeng tradisional ke dalam format digital.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "Sejarah Lokal",
    url: "https://www.youtube.com/embed/6lveJ8B_fWA",
    thumbnail: "https://img.youtube.com/vi/6lveJ8B_fWA/mqdefault.jpg",
    emoji: "🏛️",
    color: "#3498db",
    description: "Mendokumentasikan dan menceritakan peristiwa sejarah lokal, asal usul tempat, atau tokoh penting di komunitas.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "Dokumentasi Budaya",
    url: "https://www.youtube.com/embed/KHX37CEPnr0",
    thumbnail: "https://img.youtube.com/vi/KHX37CEPnr0/mqdefault.jpg",
    emoji: "🎥",
    color: "#5dade2",
    description: "Video dokumenter pendek tentang upacara adat, tarian tradisional, atau kehidupan masyarakat adat.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "Kearifan Lokal",
    url: "https://www.youtube.com/embed/t1sgDqOZr9c",
    thumbnail: "https://img.youtube.com/vi/t1sgDqOZr9c/mqdefault.jpg",
    emoji: "🌾",
    color: "#2980b9",
    description: "Mengeksplorasi nilai-nilai sosial budaya dan kearifan lokal dalam tradisi lisan serta kehidupan masyarakat.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "Karya dan Pariwisata",
    url: "https://www.youtube.com/embed/xQK4mAz3a_o",
    thumbnail: "https://img.youtube.com/vi/xQK4mAz3a_o/mqdefault.jpg",
    emoji: "🏝️",
    color: "#5499c7",
    description: "Cerita digital untuk mempromosikan kuliner, kerajinan tangan, dan destinasi wisata berbasis budaya.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "Nyai Endit's Greed Leads to Disaster | Folklore",
    url: "https://www.youtube.com/embed/2e7xT0XxkRQ",
    thumbnail: "https://img.youtube.com/vi/2e7xT0XxkRQ/mqdefault.jpg",
    emoji: "📜",
    color: "#1f618d",
    description: "Kisah legenda dari Tanah Pasundan tentang Nyai Endit yang keserakahannya membawa bencana.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "ASAL-USUL GARUT || Sejarah Berdirinya Kabupaten Garut",
    url: "https://www.youtube.com/embed/D1C2Yb-ZjzA",
    thumbnail: "https://img.youtube.com/vi/D1C2Yb-ZjzA/mqdefault.jpg",
    emoji: "🏞️",
    color: "#2874a6",
    description: "Mengulas sejarah dan asal-usul berdirinya Kabupaten Garut.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "R.A. Lasminingrat | Pendidikan Nilai-Nilai Kemanusiaan",
    url: "https://www.youtube.com/embed/4cUAwJk8uGk",
    thumbnail: "https://img.youtube.com/vi/4cUAwJk8uGk/mqdefault.jpg",
    emoji: "📚",
    color: "#2e86c1",
    description: "Video tentang R.A. Lasminingrat, seorang tokoh penting dalam kemajuan pendidikan perempuan di Indonesia.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "LUTUNG KASARUNG ~ Cerita Rakyat Jawa Barat | Dongeng Kita",
    url: "https://www.youtube.com/embed/dSQWnYuPqGI",
    thumbnail: "https://img.youtube.com/vi/dSQWnYuPqGI/mqdefault.jpg",
    emoji: "🐒",
    color: "#1b4f72",
    description: "Cerita rakyat Jawa Barat tentang legenda Lutung Kasarung yang sarat nilai moral dan budaya.",
    isActive: true,
    category: "Video Storytelling"
  },
  {
    title: "Asal Usul Kota Bandung | Cerita Rakyat Jawa Barat | Kisah Nusantara",
    url: "https://www.youtube.com/embed/-7Pyqhloctg",
    thumbnail: "https://img.youtube.com/vi/-7Pyqhloctg/mqdefault.jpg",
    emoji: "🐒",
    color: "#1b4f72",
    description: "Kisah Asal usul Kota Bandung berawal dari sungai Citarum, sungai yang terdapat di Bandung.",
    isActive: true,
    category: "Video Storytelling"
  }
];

// ===== UTILITY FUNCTIONS =====
const convertToEmbedUrl = (url) => {
  if (!url) return '';
  
  // Jika sudah format embed
  if (url.includes('youtube.com/embed/')) return url;
  
  // Jika format watch?v=...
  if (url.includes('youtube.com/watch?v=')) {
    const videoId = url.split('v=')[1];
    const ampersandPosition = videoId.indexOf('&');
    const cleanVideoId = ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;
    return `https://www.youtube.com/embed/${cleanVideoId}`;
  }
  
  // Jika format youtu.be/...
  if (url.includes('youtu.be/')) {
    const videoId = url.split('youtu.be/')[1];
    const questionMarkPosition = videoId.indexOf('?');
    const cleanVideoId = questionMarkPosition !== -1 ? videoId.substring(0, questionMarkPosition) : videoId;
    return `https://www.youtube.com/embed/${cleanVideoId}`;
  }
  
  return url;
};

const getYouTubeId = (url) => {
  let videoId = '';
  
  if (url.includes('youtube.com/embed/')) {
    videoId = url.split('embed/')[1];
    const questionMarkPosition = videoId.indexOf('?');
    videoId = questionMarkPosition !== -1 ? videoId.substring(0, questionMarkPosition) : videoId;
  } else if (url.includes('youtube.com/watch?v=')) {
    videoId = url.split('v=')[1];
    const ampersandPosition = videoId.indexOf('&');
    videoId = ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;
  } else if (url.includes('youtu.be/')) {
    videoId = url.split('youtu.be/')[1];
    const questionMarkPosition = videoId.indexOf('?');
    videoId = questionMarkPosition !== -1 ? videoId.substring(0, questionMarkPosition) : videoId;
  }
  
  return videoId;
};

const getThumbnailUrl = (url) => {
  const videoId = getYouTubeId(url);
  return videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : '';
};

// ===== COMPONENT =====
const Eksplorasi = () => {
  // ===== STATE MANAGEMENT =====
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [userRole, setUserRole] = useState('siswa');
  const [showAddVideoForm, setShowAddVideoForm] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [deleteConfirmIndex, setDeleteConfirmIndex] = useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState('');
  
  const [newVideo, setNewVideo] = useState({
    title: '',
    url: '',
    emoji: '🎬',
    color: '#3498db',
    description: '',
    isActive: true
  });
  
  const [videos, setVideos] = useState(INITIAL_VIDEOS);

  useEffect(() => {
    const me = getCurrentUser();
    if (me?.role) setUserRole(me.role);
  }, []);

  // ===== EFFECTS =====
  useEffect(() => {
    migrateLegacyKey('eksplorasiVideos');

    const savedVideos = userGetItem('eksplorasiVideos');
    if (savedVideos) {
      try {
        setVideos(JSON.parse(savedVideos));
      } catch (error) {
        console.error('Error loading videos:', error);
      }
    }

    (async () => {
      try {
        const res = await fetchUserData('eksplorasiVideos');
        if (Array.isArray(res?.data) && res.data.length > 0) {
          setVideos(res.data);
          userSetItem('eksplorasiVideos', JSON.stringify(res.data));
        }
      } catch (error) {
        console.warn('Video Eksplorasi dari server belum tersedia:', error.message);
      }
    })();
  }, []);

  useEffect(() => {
    if (userRole !== 'guru') return;

    try {
      userSetItem('eksplorasiVideos', JSON.stringify(videos));
    } catch (error) {
      console.error('Error saving videos:', error);
    }

    const timer = setTimeout(() => {
      saveUserData('eksplorasiVideos', videos).catch((error) => {
        console.warn('Gagal sync video ke server:', error.message);
      });
    }, 800);

    return () => clearTimeout(timer);
  }, [videos, userRole]);

  // ===== HANDLERS =====
  const resetForm = useCallback(() => {
    setNewVideo({
      title: '',
      url: '',
      emoji: '🎬',
      color: '#3498db',
      description: '',
      isActive: true
    });
    setThumbnailUrl('');
    setEditingIndex(null);
  }, []);

  const handleUrlChange = useCallback((e) => {
    const url = e.target.value;
    setNewVideo(prev => ({ ...prev, url }));
    
    const embedUrl = convertToEmbedUrl(url);
    const videoId = getYouTubeId(embedUrl);
    setThumbnailUrl(videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : '');
  }, []);

  const handleAddVideo = useCallback(() => {
    if (!newVideo.title.trim() || !newVideo.url.trim()) {
      toast.warn('Judul dan URL video wajib diisi!');
      return;
    }

    const embedUrl = convertToEmbedUrl(newVideo.url.trim());
    const videoId = getYouTubeId(embedUrl);
    
    if (!videoId) {
      toast.error('URL YouTube tidak valid. Gunakan format watch, youtu.be, atau embed.');
      return;
    }

    const videoToAdd = {
      ...newVideo,
      url: embedUrl,
      thumbnail: getThumbnailUrl(embedUrl),
      isActive: true
    };

    if (editingIndex !== null) {
      setVideos(prev => prev.map((video, index) => 
        index === editingIndex ? videoToAdd : video
      ));
    } else {
      setVideos(prev => [...prev, videoToAdd]);
    }

    resetForm();
    setShowAddVideoForm(false);
  }, [newVideo, editingIndex, resetForm]);

  const handleVideoSelect = useCallback((video) => {
    setSelectedVideo(video);
  }, []);

  const closeVideoModal = useCallback(() => {
    setSelectedVideo(null);
  }, []);

  const videoModalRef = useModalA11y(!!selectedVideo, closeVideoModal);

  const handleDeleteVideo = useCallback((index) => {
    setDeleteConfirmIndex(index);
  }, []);

  const confirmDeleteVideo = useCallback(() => {
    if (deleteConfirmIndex === null) return;
    setVideos(prev => prev.filter((_, i) => i !== deleteConfirmIndex));
    toast.success('Video berhasil dihapus');
    setDeleteConfirmIndex(null);
  }, [deleteConfirmIndex]);

  const handleEditVideo = useCallback((video, index) => {
    const originalUrl = video.url.replace('/embed/', '/watch?v=');
    setNewVideo({
      title: video.title,
      url: originalUrl,
      emoji: video.emoji,
      color: video.color,
      description: video.description,
      isActive: video.isActive
    });
    setEditingIndex(index);
    setShowAddVideoForm(true);
    setThumbnailUrl(video.thumbnail);
  }, []);

  const toggleVideoActive = useCallback((index) => {
    setVideos(prev => prev.map((video, i) => 
      i === index ? { ...video, isActive: !video.isActive } : video
    ));
  }, []);

  const visibleVideos = useMemo(
    () => videos.filter((video) => userRole === 'guru' || video.isActive),
    [videos, userRole]
  );

  // ===== RENDER HELPERS =====
  const renderHeader = () => (
    <div className="eksplorasi-header">
      <div className="header-content">
        <div className="title-wrapper">
          <h1>Petualangan Cerita Seru! <span className="animated-emoji"></span></h1>
        </div>
        <p className="subtitle">Yuk, jelajahi dunia cerita menarik tentang budaya dan kearifan lokal Indonesia!</p>

        {userRole === 'guru' && (
          <span className="role-badge guru-badge">👩‍🏫 Mode Guru — kelola video eksplorasi</span>
        )}

        <div className="search-bar">
          <input type="text" placeholder="Cari cerita favoritmu... 🔍" />
          <button className="search-btn">Jelajahi!</button>
        </div>
      </div>
      <div className="header-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
      </div>
    </div>
  );

  const renderCategories = () => (
    <div className="quick-categories">
      <h2>Pilih Kategori Favoritmu! </h2>
      <div className="category-buttons">
        <button className="category-btn video">Video Storytelling 🎬</button>
        <button className="category-btn photo">Photo Storytelling 📸</button>
        <button className="category-btn audio">Audio Storytelling 🎧</button>
        <button className="category-btn infographic">Infografis Interaktif 📊</button>
      </div>
    </div>
  );

  const renderGuruControls = () => {
    if (userRole !== 'guru') return null;
    
    const activeVideos = videos.filter(v => v.isActive).length;
    const inactiveVideos = videos.filter(v => !v.isActive).length;

    return (
      <div className="guru-controls">
        <div className="guru-header">
          <h3>🛠️ Panel Kontrol Guru</h3>
          <p>Kelola konten video pembelajaran untuk siswa</p>
        </div>
        <div className="guru-actions">
          <button 
            className="guru-btn add-video"
            onClick={() => setShowAddVideoForm(true)}
          >
            ➕ Tambah Video Baru
          </button>
          <button 
            className="guru-btn manage-videos"
            onClick={() =>
              toast.info(
                `Total video: ${videos.length} · Aktif: ${activeVideos} · Non-aktif: ${inactiveVideos}`
              )
            }
          >
            📊 Kelola Video
          </button>
          <div className="video-stats">
            <span>📹 {videos.length} Video</span>
            <span>✅ {activeVideos} Aktif</span>
            <span>❌ {inactiveVideos} Non-aktif</span>
          </div>
        </div>

        {showAddVideoForm && renderVideoForm()}
      </div>
    );
  };

  const renderVideoForm = () => (
    <div className="video-form-modal">
      <div className="form-header">
        <h4>{editingIndex !== null ? '✏️ Edit Video' : '➕ Tambah Video Baru'}</h4>
        <button 
          className="close-form" 
          onClick={() => {
            setShowAddVideoForm(false);
            resetForm();
          }}
        >
          ✖️
        </button>
      </div>
      <div className="form-content">
        <div className="form-row">
          <label>Judul Video:</label>
          <input
            type="text"
            value={newVideo.title}
            onChange={(e) => setNewVideo(prev => ({ ...prev, title: e.target.value }))}
            placeholder="Masukkan judul video"
          />
        </div>
        
        <div className="form-row">
          <label>URL YouTube:</label>
          <input
            type="text"
            value={newVideo.url}
            onChange={handleUrlChange}
            placeholder="Contoh: https://www.youtube.com/watch?v=VIDEO_ID"
          />
          <div className="url-examples">
            <small>Format yang didukung:</small>
            <div className="example-links">
              <span>• https://www.youtube.com/watch?v=dQw4w9WgXcQ</span>
              <span>• https://youtu.be/dQw4w9WgXcQ</span>
              <span>• https://www.youtube.com/embed/dQw4w9WgXcQ</span>
            </div>
          </div>
        </div>
        
        <div className="form-row">
          <label>Preview Thumbnail:</label>
          <div 
            className="thumbnail-preview"
            style={{
              backgroundImage: thumbnailUrl
                ? `url(${thumbnailUrl})`
                : 'linear-gradient(135deg, #3498db 0%, #2c3e50 100%)'
            }}
          >
            {!thumbnailUrl && <span className="preview-placeholder">Thumbnail akan muncul di sini</span>}
          </div>
        </div>
        
        <div className="form-row">
          <label>Emoji:</label>
          <div className="emoji-picker">
            {EMOJI_OPTIONS.map((emoji, index) => (
              <button
                key={index}
                className={`emoji-option ${newVideo.emoji === emoji ? 'selected' : ''}`}
                onClick={() => setNewVideo(prev => ({ ...prev, emoji }))}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
        
        <div className="form-row">
          <label>Warna:</label>
          <div className="color-picker">
            {COLOR_OPTIONS.map((color, index) => (
              <button
                key={index}
                className={`color-option ${newVideo.color === color ? 'selected' : ''}`}
                style={{ backgroundColor: color }}
                onClick={() => setNewVideo(prev => ({ ...prev, color }))}
                title={color}
              />
            ))}
          </div>
        </div>
        
        <div className="form-row">
          <label>Deskripsi:</label>
          <textarea
            value={newVideo.description}
            onChange={(e) => setNewVideo(prev => ({ ...prev, description: e.target.value }))}
            placeholder="Masukkan deskripsi video"
            rows="3"
          />
        </div>
        
        <div className="form-row">
          <label>
            <input
              type="checkbox"
              checked={newVideo.isActive}
              onChange={(e) => setNewVideo(prev => ({ ...prev, isActive: e.target.checked }))}
            />
            Tampilkan untuk siswa
          </label>
        </div>
        
        <div className="form-actions">
          <button className="submit-btn" onClick={handleAddVideo}>
            {editingIndex !== null ? '💾 Simpan Perubahan' : '➕ Tambah Video'}
          </button>
          <button 
            className="cancel-btn" 
            onClick={() => {
              setShowAddVideoForm(false);
              resetForm();
            }}
          >
            ❌ Batal
          </button>
        </div>
      </div>
    </div>
  );

  const renderVideoCard = (video, index) => (
    <div 
      key={index} 
      className={`video-card ${!video.isActive ? 'inactive' : ''}`}
      style={{ '--card-color': video.color }}
    >
      {userRole === 'guru' && (
        <div className="guru-card-controls">
          <button 
            className="edit-btn"
            onClick={() => handleEditVideo(video, index)}
            title="Edit video"
          >
            ✏️
          </button>
          <button 
            className="delete-btn"
            onClick={() => handleDeleteVideo(index)}
            title="Hapus video"
          >
            🗑️
          </button>
          <button 
            className={`toggle-btn ${video.isActive ? 'active' : 'inactive'}`}
            onClick={() => toggleVideoActive(index)}
            title={video.isActive ? 'Nonaktifkan' : 'Aktifkan'}
          >
            {video.isActive ? '✅' : '❌'}
          </button>
          {!video.isActive && <span className="inactive-label">Tidak Aktif</span>}
        </div>
      )}

      <div className="card-badge">{video.isActive ? 'NEW' : 'HIDDEN'}</div>
      <div className="card-header">
        <div className="card-emoji">{video.emoji}</div>
        <h2>{video.title}</h2>
      </div>
      <p className="card-description">{video.description}</p>
      <div className="video-preview">
        {video.thumbnail ? (
          <div 
            className="video-thumbnail"
            style={{ 
              backgroundImage: `url(${video.thumbnail})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
            onClick={() => handleVideoSelect(video)}
          >
            <div className="play-overlay">
              <span className="play-icon">▶️</span>
            </div>
          </div>
        ) : (
          <div className="video-thumbnail no-thumbnail">
            <div className="play-overlay">
              <span className="play-icon">▶️</span>
            </div>
            <span className="thumbnail-text">Thumbnail tidak tersedia</span>
          </div>
        )}
      </div>
      <button 
        className="play-button" 
        onClick={() => handleVideoSelect(video)}
        disabled={!video.isActive && userRole === 'siswa'}
      >
        <span className="play-icon">🎬</span>
        {video.isActive ? 'Tonton Sekarang!' : 'Tidak Tersedia'}
      </button>
    </div>
  );

  const renderVideoModal = () => {
    if (!selectedVideo) return null;
    
    const handleEditFromModal = () => {
      const index = videos.findIndex(v => v.url === selectedVideo.url);
      if (index !== -1) {
        const originalUrl = selectedVideo.url.replace('embed/', 'watch?v=');
        setNewVideo({
          ...videos[index],
          url: originalUrl
        });
        setEditingIndex(index);
        setShowAddVideoForm(true);
        closeVideoModal();
      }
    };

    return (
      <div className="video-modal-overlay" onClick={closeVideoModal} role="presentation">
        <div
          ref={videoModalRef}
          className="video-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="eksplorasi-video-modal-title"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h3 id="eksplorasi-video-modal-title">
              <span aria-hidden="true">{selectedVideo.emoji} </span>
              {selectedVideo.title}
            </h3>
            <button type="button" className="close-modal" onClick={closeVideoModal} aria-label="Tutup video">
              ✖️
            </button>
          </div>
          <div className="modal-video">
            <iframe
              src={selectedVideo.url}
              title={selectedVideo.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div className="modal-footer">
            <p>{selectedVideo.description}</p>
            <div className="modal-actions">
              <button className="action-btn favorite">💖 Tambah ke Favorit</button>
              <button className="action-btn share">📤 Bagikan</button>
              {userRole === 'guru' && (
                <button className="action-btn edit" onClick={handleEditFromModal}>
                  ✏️ Edit Video
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderProgressSection = () => (
    <div className="progress-section">
      <h2>Pencapaian Belajarmu! 🏆</h2>
      <div className="progress-cards">
        <div className="progress-card">
          <div className="progress-emoji">🎬</div>
          <h4>Cerita Ditonton</h4>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: '60%' }}></div>
          </div>
          <span>{videos.filter(v => v.isActive).length} video tersedia</span>
        </div>
        <div className="progress-card">
          <div className="progress-emoji">⭐</div>
          <h4>Bintang Dikumpulkan</h4>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: '40%' }}></div>
          </div>
          <span>8/20 bintang</span>
        </div>
        <div className="progress-card">
          <div className="progress-emoji">🏅</div>
          <h4>Lencana</h4>
          <div className="badges">
            <span className="badge">🥇</span>
            <span className="badge">🥈</span>
            <span className="badge locked">🔒</span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderFooter = () => (
    <div className="eksplorasi-footer">
      <div className="footer-content">
        <h3>Selamat Menonton dan Belajar! 🎉</h3>
        <p>Setiap cerita adalah petualangan baru yang menunggu untuk dijelajahi!</p>
        <div className="footer-actions">
          <button className="footer-btn">📚 Lihat Cerita Lainnya</button>
          {userRole === 'guru' && (
            <button 
              className="footer-btn guru"
              onClick={() => setShowAddVideoForm(true)}
            >
              👩‍🏫 Kelola Video
            </button>
          )}
        </div>
      </div>
      <div className="footer-decoration">
        <div className="bouncing-emoji">🎈</div>
        <div className="bouncing-emoji">🎨</div>
        <div className="bouncing-emoji">📚</div>
      </div>
    </div>
  );

  // ===== MAIN RENDER =====
  return (
    <div className="eksplorasi-container">
      {renderHeader()}
      {renderCategories()}
      {renderGuruControls()}
      
      <div className="video-grid">
        {visibleVideos.length === 0 ? (
          <EmptyList
            icon="🎬"
            title="Belum ada video untuk dijelajahi"
            message={
              userRole === 'guru'
                ? 'Tambahkan video pertama lewat panel kontrol guru di atas.'
                : 'Video pembelajaran akan segera tersedia. Kembali lagi nanti!'
            }
            action={
              userRole === 'guru' ? (
                <button type="button" className="footer-btn guru" onClick={() => setShowAddVideoForm(true)}>
                  ➕ Tambah Video Pertama
                </button>
              ) : null
            }
          />
        ) : (
          visibleVideos.map((video) => {
            const index = videos.indexOf(video);
            return renderVideoCard(video, index);
          })
        )}
      </div>

      <ConfirmDialog
        open={deleteConfirmIndex !== null}
        title="Hapus video?"
        message="Video yang dihapus tidak dapat dikembalikan. Lanjutkan?"
        confirmLabel="Ya, hapus"
        onConfirm={confirmDeleteVideo}
        onCancel={() => setDeleteConfirmIndex(null)}
      />

      {renderVideoModal()}
      {renderProgressSection()}
      {renderFooter()}
    </div>
  );
};

export default Eksplorasi;